import React from 'react'
import './index.scss'

const techs = [
  'Javascript',
  'React',
  'Typescript',
  'NodeJs',
  'MongoDB',
  'PostgreSQL',
  'REST API',
  'GraphQL',
  'Shopify'
]

const Home = () => {
  return (
    <div className="home">
      <h4 className="home__name">aditya gyawali</h4>
      <p className="home__title">
        Front End Developer
        <a href="https://www.rensoriginal.com" target="__blank">
          @Rens Original
        </a>
      </p>
      <div className="tech">
        {techs.map(tech => (
          <span key={tech}>{tech}</span>
        ))}
      </div>
    </div>
  )
}

export default Home
